import React from "react";
import { Icon } from "@iconify/react"
import "./TaskCompleted.css";

const TaskCompleted = ({ onViewCurrent }) => (
  <div className="notif-task-completed">
    <Icon icon="carbon:checkmark-outline" size={100} className="notif-task-completed__icon" strokeWidth={1.5} width = "92px" height= "92px" />
    <p className="notif-task-completed__primary">Your task submitted successfully.</p>
    <p className="notif-task-completed__secondary">
      The task you're looking for has been moved to archived tasks
    </p>
    <button className="notif-task-completed__btn" onClick={onViewCurrent}>
      View current tasks
    </button>
  </div>
);

export default TaskCompleted;